import { useEffect, useState } from 'react'

import isClient from '@equifax-ui/utils/browser/isClient'

import { Button } from '@/components'

import { SOURCE_URL_LABEL } from '@/constants/api'

import ImageError404 from './components/ImageError/ImageError'

import styles from './Page404.module.scss'

const Page404 = () => {
  const [sourceURL, setSourceURL] = useState('/')

  useEffect(() => {
    const sourceURL =
      (isClient() && JSON.parse(sessionStorage.getItem(SOURCE_URL_LABEL))) ||
      '/'

    setSourceURL(sourceURL)
  }, [])

  return (
    <section className={styles.page404}>
      <ImageError404 />

      <h1 className={styles.page404__title}>Ops! Página não encontrada</h1>

      <p className={styles.page404__text}>
        Infelizmente, a página que você está procurando não foi encontrada. Por
        favor, tente novamente em alguns instantes.
      </p>

      <Button
        tagName="a"
        variant="primary"
        id="page-404-back-button"
        href={sourceURL}
        className={styles.page404__button}
      >
        Voltar
      </Button>
    </section>
  )
}

export default Page404
